// extracted by mini-css-extract-plugin
export var dropdown = "_em-0";
export var imagePlaceholder = "_em-2";
export var imageWrapper = "_em-3";
export var productImage = "_em-1";
export var truncateContainer = "_em-4";
export var truncateText = "_em-5";